<template>
  <div>
    <b-modal
      title="資料審核"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <section class="member-area">
        <h3>互助人(會員)</h3>

        <!-- <div>
          <div class="bg-grey">會員編號</div>
          <div class="bg-grey">組別</div>
          <div class="bg-grey">姓名</div>
          <div class="bg-grey">出生日期</div>
          <div class="bg-grey">身分證</div>
          <div class="bg-grey">組長編號</div>
        </div>

        <div>
          <div>{{ data.number }}</div>
          <div>{{ data.plan }}</div>
          <div>{{ data.member_name }}</div>
          <div>{{ convertRocDate(data.member_birthday) }}</div>
          <div>{{ data.member_ID_number }}</div>
          <div>{{ data.sales_number }}</div>
        </div>

        <div>
          <div class="bg-grey">戶籍地址</div>
          <div class="span-5">{{ data.pay_Haddress }}</div>
        </div>

        <div>
          <div class="bg-grey">入會日期</div>
          <div class="bg-grey">身故日期</div>
          <div class="bg-grey">年資</div>
          <div class="bg-grey">停效(月)</div>
          <div class="bg-red">實際年資</div>
          <div class="bg-grey">組長姓名</div>
        </div>

        <div>
          <div>{{ convertRocDate(data.join_date) }}</div>
          <div>{{ convertRocDate(data.dead_at) }}</div>
          <div>{{ data.seniority_month }}月 ({{ data.seniority_day }}天)</div>
          <div>{{ data.stop_count_M }}</div>
          <div><b-form-input type="number" v-model="data.claim_seniority"></b-form-input></div>
          <div>{{ data.sales_name }}</div>
        </div> -->
        <div>
          <div class="bg-grey">會員編號</div>
          <div class="bg-grey">姓名</div>
          <div class="bg-grey">組長姓名</div>
          <div class="bg-grey">組長編號</div>
          <div class="bg-red">使用生命禮儀</div>
        </div>

        <div>
          <div>{{ data.number }}</div>
          <div>{{ data.member_name }}</div>
          <div>{{ data.sales_name }}</div>
          <div>{{ data.sales_number }}</div>
          <div><b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.claim_recommend"></b-form-checkbox></div>
        </div>

        <div>
          <div class="bg-grey">入會日期</div>
          <div class="bg-grey">身故日期</div>
          <div class="bg-grey">年資</div>
          <div class="bg-grey">停效(月)</div>
          <div class="bg-red">實際年資</div>

        </div>

        <div>
          <div>{{ convertRocDate(data.join_date) }}</div>
          <div>{{ convertRocDate(data.dead_at) }}</div>
          <div>{{ data.seniority_month }}月 ({{ data.seniority_day }}天)</div>
          <div>{{ data.stop_count_M }}</div>
          <div><b-form-input type="number" v-model="data.claim_seniority"></b-form-input></div>
        </div>
      </section>

      <!-- <section class="beneficiary-area">
        <h3>互助金受款人</h3>

        <div>
          <div class="bg-grey">姓名</div>
          <div class="bg-grey">出生日期</div>
          <div class="bg-grey">身分證</div>
          <div class="bg-grey">手機</div>
          <div class="bg-yellow">預約生命禮儀</div>
          <div class="bg-red">使用生命禮儀</div>
        </div>

        <div>
          <div>{{ data.beneficiary_name }}</div>
          <div>{{ convertRocDate(data.beneficiary_birthday) }}</div>
          <div>{{ data.beneficiary_ID_number }}</div>
          <div>{{ data.beneficiary_cellphone }}</div>
          <div>{{ data.recommend ? '是' : '否' }}</div>
          <div><b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.claim_recommend"></b-form-checkbox></div>
        </div>
      </section> -->

      <section class="claim-area">
        <h3>理賠設定</h3>

        <div class="split-5">
          <div class="bg-red">預計發放日期</div>
          <div class="bg-green">自訂加款名稱(最多十個字)</div>
          <div class="bg-green">自訂加錢金額</div>
          <div class="bg-red">自訂扣款名稱(最多十個字)</div>
          <div class="bg-red">自訂扣款金額</div>
        </div>

        <div class="split-5">
          <div>
            <date-picker
              v-model="data.pay_at"
              :position="'left'"
              :manualInput="true"
              placeholder="日期範例：065-02-26"
            ></date-picker>
          </div>
          <div><b-form-input v-model="data.claim_other_add_name"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_other_add"></b-form-input></div>
          <div><b-form-input v-model="data.claim_other_reduce_name" max="10"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_other_reduce"></b-form-input></div>
        </div>

        <div class="split-4">
          <div class="bg-yellow">墊繳金額</div>
          <div class="bg-yellow">墊繳手續費</div>
          <div class="bg-yellow">預領金額</div>
          <div class="bg-yellow">預領手續費</div>
        </div>

        <div class="split-4">
          <div><b-form-input type="number" v-model="data.claim_behalf"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_behalf_fee"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_cash_advance"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_cash_advance_fee"></b-form-input></div>
        </div>

        <div class="split-6">
          <div class="bg-red">慰問基金</div>
          <div class="bg-red">安定基金</div>
          <div class="bg-red">行政費</div>
          <div class="bg-red">{{ annualFee }}</div>
          <div class="bg-red">遞延金額</div>
          <div class="bg-red">遞延人數</div>
        </div>

        <div class="split-6">
          <div><b-form-input type="number" v-model="data.claim_condolence"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_stable"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_administrative"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_year"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_defferred"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_defferred_count"></b-form-input></div>
        </div>

        <div class="split-4">
          <div class="bg-red">未繳款項描述(最多十六個字)</div>
          <div class="bg-red">未繳款項</div>
          <div class="bg-red">受理日期</div>
          <div class="bg-grey">預估補助金額</div>
        </div>

        <div class="split-4">
          <div><b-form-input v-model="data.claim_unpay_remark"></b-form-input></div>
          <div><b-form-input type="number" v-model="data.claim_unpay"></b-form-input></div>
          <div>
             <date-picker
              v-model="data.accept_at"
              :position="'left'"
              :manualInput="true"
              placeholder="日期範例：065-02-26"
            ></date-picker>
          </div>
          <div>{{ subsidyAmount }}</div>
        </div>

        <div class="split-4">
          <div class="bg-red">備註說明</div>

          <div class="span-4">
            <b-form-textarea
              v-model="data.claim_remark"
              rows="3"
            />
          </div>
        </div>
      </section>

      <section v-if="this.options.period.length > 0" class="mt-4">
        <b-tabs
          ref="tabs"
          v-model="search.period"
          pills
          class="mb-4"
          @input="getBill()"
        >
          <b-tab
            v-for="(item, index) in options.period"
            :key="index"
            :title="item.label"
          />
        </b-tabs>

        <tables-page
          :tableData="bill.table_data"
          :tableFields="bill.table_fields"
        >
          <template #cell(no)="row">
            {{ row.index + 1 }}
          </template>

          <template #cell(type)="row">
            <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
          </template>

          <template #cell(dead_at)="row">
            {{ convertRocDate(row.item.dead_at, false) }}
          </template>

          <template #cell(payment_at)="row">
            {{ convertRocDate(row.item.payment_at, false) }}
          </template>

          <template #cell(updated_at)="row">
            {{ convertRocDate(row.item.updated_at) }}
          </template>

          <template #cell(late_payment)="row">
            <span class="text-danger">{{ row.item.payment_at > row.item.dead_at ? '遲繳' : ''  }}</span>
          </template>

          <template #custom-foot>
            <tr>
              <td class="text-right" colspan="4">
                總計
              </td>

              <td class="text-center">
                {{ calculateRowsSum(bill.table_data, 'amount') }}
              </td>
            </tr>
          </template>
        </tables-page>
      </section>

      <section v-if="this.loan.table_data.length > 0">
        <hr class="mt-2 mb-2"/>

        <tables-page
          :tableData="loan.table_data"
          :tableFields="loan.table_fields"
          :pageData="loan.page"
          @result="getLoan"
        >
          <template #cell(loan_at)="row">
            {{ convertRocDate(row.item.loan_at) }}
          </template>

          <template #cell(expiry_at)="row">
            {{ convertRocDate(row.item.expiry_at) }}
          </template>

          <template #cell(repayment_at)="row">
            {{ convertRocDate(row.item.repayment_at) }}
          </template>
        </tables-page>
      </section>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import contractApi from "@/models/API/contractApi";
import { convertRocDate, getRocYearAndMonthOfPeriod, getBillTypeColor, getBillFeeDescription, calculateRowsSum } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'DataReviewModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      options: {
        period: [],
      },
      search: {
        period: 0
      },
      bill: {
        table_fields: [
        {
          key: "no",
          label: "序號",
        },
        {
          key: "month",
          label: "帳單月份",
        },
        {
          key: "period",
          label: "帳單期別",
        },
        {
          key: "type",
          label: "類型",
        },
        {
          key: "amount",
          label: "互助金",
        },
        {
          key: "dead_at",
          label: "繳款期限",
        },
        {
          key: "payment_at",
          label: "繳款日期",
        },
        {
          key: "payment_source",
          label: "繳款來源",
        },
        {
          key: "remark",
          label: "備註",
        },
        {
          key: "updated_at",
          label: "異動時間",
        },
        {
          key: "late_payment",
          label: "遲繳",
        },
        ],
        table_data: [],
        page: {}
      },
      loan: {
        table_fields: [
          {
            key: "loan_at",
            label: "借款日",
          },
          {
            key: "expiry_at",
            label: "到期日",
          },
          {
            key: "repayment_at",
            label: "還款日",
          },
          {
            key: "amount",
            label: "金額",
          },
          {
            key: "fee",
            label: "手續費",
          }
        ],
        table_data: [],
        page: {},
      }

    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    // 預估金額
    subsidyAmount() {
      const { claim_condolence, claim_other_add, claim_other_reduce, claim_behalf, claim_behalf_fee, claim_cash_advance, claim_cash_advance_fee, claim_stable, claim_administrative, claim_year, claim_defferred, claim_unpay } = this.data;

      return Number(claim_condolence) +
            Number(claim_other_add) -
            Number(claim_other_reduce) -
            Number(claim_behalf) -
            Number(claim_behalf_fee) -
            Number(claim_cash_advance) -
            Number(claim_cash_advance_fee) -
            Number(claim_stable) -
            Number(claim_administrative) -
            Number(claim_year) -
            Number(claim_defferred) -
            Number(claim_unpay);
    },
    // 年費
    annualFee() {
      const seniority_month = this.data.seniority_month;
      let text = ''

      if (seniority_month > 12 && seniority_month % 12 !== 0) {
        const quo = Math.floor(seniority_month / 12);

        text = `年費(${seniority_month} - ${quo * 12}) = ${seniority_month % 12}`;
      } else {
        text = '年費';
      }

      return text;
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.behalfHistoryDataHandler(this.data);
          this.getLoan();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    calculateRowsSum,
    // 首次載入讀取
    load() {
      this.loan.page = Object.assign({}, this.contractApi.page);
    },
    // 墊繳日期資料處理
    behalfHistoryDataHandler(data) {
      let behalf_date = [];
      let new_behalf_history = '';

      if (data.behalf_at && data.behalf_end) new_behalf_history = `${data.behalf_at}~${data.behalf_end}`

      if (data.behalf_history && new_behalf_history) new_behalf_history += `,${data.behalf_history}`
      else if (data.behalf_history) new_behalf_history = data.behalf_history;

      if (new_behalf_history) {
        let list = new_behalf_history.split(',');

        behalf_date = list.map(item => {
          const start_date = item.split('~')[0];
          const end_date = item.split('~')[1];

          return {
            start_date: getRocYearAndMonthOfPeriod(start_date),
            end_date: getRocYearAndMonthOfPeriod(end_date)
          }
        });
      }

      this.periodTabsDataHandler(behalf_date);
    },
    // 期數tabs資料處理
    periodTabsDataHandler(behalf_date) {
      this.options.period = [];

      this.options.period = behalf_date.map((item, index) => {
        return {
           ...item,
          value: index,
          label: `${item.start_date} ~ ${item.end_date}`,
        }
      });

     this.getBill();
    },
    // 查詢帳單
    getBill() {
      if (this.options.period.length === 0) return;

      this.status.isLoading = true;
      const { start_date, end_date } = this.options.period.find(item => item.value === this.search.period);

      const params = {
        'member_id': this.data.id,
        'period_S': start_date,
        'period_E': end_date
      };

      this.billApi.getBill((response) => {
        const res = response.data;

        this.bill.table_data = res.data[0].details;

        this.status.isLoading = false;
      }, params, false)
    },
    // 查詢預領
    getLoan(pageIndex = null) {
      this.status.isLoading = true;

      const params = {
        'member_id': this.data.id,
        'PageSize': this.loan.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.loan.page.pageIndex,
      };

      this.contractApi.getLoan((response) => {
        const res = response.data;

        this.loan.page.totalCount = res.total;
        this.loan.table_data = res.data;

        this.status.isLoading = false;
      }, params, false)
    },
    sumit() {
      this.$emit('sumit');
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-grey {
  background: #CCC;
  font-weight: bold;
}
.bg-red {
  background: #ff7d7d;
  font-weight: bold;
}
.bg-yellow {
  background: #e3cd2c;
  font-weight: bold;
}
.bg-green {
  background: #75dd5a;
  font-weight: bold;
}
h3 {
  border: 1px solid #907c7c;
  background: #d6daff;
  font-weight: bold;
  margin: 0;
  text-align: center;
}

.member-area {
  width: 100%;
  font-size: 20px;
  margin-bottom: 30px;
  > div {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 2px;
    &:not(:first-child) {
      margin-top: 2px;
    }
    > div {
      border: 1px solid #907c7c;
      &.span-5 {
        grid-column: span 5;
      }
    }
  }
}

.beneficiary-area {
  width: 100%;
  font-size: 20px;
  margin-bottom: 30px;
  > div {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 2px;
    &:not(:first-child) {
      margin-top: 2px;
    }
    > div {
      border: 1px solid #907c7c;
    }
  }
}

.claim-area {
  width: 100%;
  font-size: 20px;
   > div {
    display: grid;
    gap: 2px;
    &.split-4 {
      grid-template-columns: repeat(4, 1fr);
    }
    &.split-5 {
      grid-template-columns: 1fr 250px 1fr 250px 1fr;
    }
    &.split-6 {
      grid-template-columns: repeat(6, 1fr);
    }
    &:not(:first-child) {
      margin-top: 2px;
    }
    > div {
      border: 1px solid #907c7c;
      &.span-4 {
        grid-column: span 3;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/DataReviewModal.vue